import { queryOptions, useQuery } from '@tanstack/react-query'
import { DaoOverviewStats } from 'Modules'

import { AppAdmin } from 'api/app-admin'

/**
 * DAO Voting overview stats (GET /admin/dao-voting/overview).
 * queryOptions factory so the key/fetcher can be reused for prefetching.
 */
export const daoOverviewQueryOptions = () =>
  queryOptions({
    queryKey: ['daoVoting', 'overview'],
    queryFn: async () => {
      const res = await AppAdmin.getDaoVotingOverview()
      return res.data?.data as DaoOverviewStats
    },
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  })

export const useDaoOverview = () => {
  const query = useQuery(daoOverviewQueryOptions())

  return {
    stats: query.data,
    isLoading: query.isLoading,
    error: query.error,
  }
}
